<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr
        :btitle="'ONT Pots Port'"
        style="min-height: 100%"
        :closeButton="false"
        :collapseStatus="'close'"
      >
        <!-- 按钮 -->
        <div class="form-inline" style="height: 35px">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="loadOntPotsPort()"
                class="btn"
                :class="{}"
                style="padding: 0px"
              >
                <i class="fa fa-refresh page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>
        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th
                v-for="(value, key) in ontPotsPort.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody style="height: 100%">
            <tr v-for="row in ontPotsPort.data" :key="row.port">
              <td v-for="(value, key) in row" :key="key">
                <div>{{ value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </block-cntr>
    </div>
  </div>
</template>
<script>
import BlockCntr from "@/components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontPotsPort",
  data() {
    return {
      iBox: {},
      ontPotsPort: "",
    }
  },
  props: ["ontIndex"],
  components: {
    BlockCntr,
    InfoBox,
  },
  created() {
    this.loadOntPotsPort()
  },
  methods: {
    loadOntPotsPort() {
      get("ontPotsPort?ontIndex=" + this.ontIndex)
        .then((res) => (this.ontPotsPort = res.data))
        .catch((err) => {})
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>>